export default __webpack_public_path__ + "static/media/done.9651576c.svg";